import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input, FormGroup, Label, FormFeedback, FormText } from 'reactstrap';

class CheckboxFieldGroup extends Component {
    render() {
        const { field, value, label, error, onChange, description, className } = this.props;

        return (
            <FormGroup check className={className}>
                <Label check>
                    <Input type="checkbox"
                        name={field}
                        checked={value}
                        onChange={onChange}
                        invalid={error ? true : false} /> {label}
                </Label>
                {error && <FormFeedback>{error}</FormFeedback>}
                {description && <FormText>{description}</FormText>}
            </FormGroup>
        );
    }
}

CheckboxFieldGroup.propTypes = {
    field: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired
}

export default CheckboxFieldGroup;
